import { render, staticRenderFns } from "./BibleSchool.vue?vue&type=template&id=584cdc01&"
import script from "./BibleSchool.vue?vue&type=script&lang=js&"
export * from "./BibleSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports